<template>
  <div id="impact-product-header" class="product-header" v-if="product">
    <h1>{{ heading || "Help Make an Impact" }}</h1>
    <p class="tagline">{{ product.meta.description }}</p>

    <div class="goal-wrapper">
      <div class="progress-bar">
        <div class="progress-bar-wrapper">
          <div
            class="progress-bar-inner"
            :style="{ width: goalProgress + '%' }"
          ></div>
        </div>
      </div>
      <p class="goal">
        ${{ formatCurrency(product.meta.currentDonationAmount) }} of ${{
          formatCurrency(product.meta.goalAmount)
        }}
        raised
      </p>
      <p>
        <span class="deadline">{{ endDateText }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "ImpactProjectHeader",

  props: {
    heading: {
      type: String,
      required: false,
    },
  },
  computed: {
    endDateText() {
      const days = moment(this.product.meta.dueDate).diff(moment(), "days");

      if (this.goalProgress === 100) return "Achieved!";
      if (days < 1 && this.goalProgress != 100) return "Completed";
      return `CLOSES ${moment(this.product.meta.dueDate).format(
        "Do MMMM YYYY"
      )}`;
    },
    goalProgress: function () {
      const progress =
        (this.product.meta.currentDonationAmount /
          this.product.meta.goalAmount) *
        100;
      return progress <= 100 ? progress : 100;
    },
    ...mapState({
      product: (state) => state.product.product,
    }),
  },

  methods: {
    formatCurrency(num) {
      const currencyStr = num.toFixed(2).toString().replace(".00", "");

      if (num >= 10000) {
        // Format with spaces - 10 000, 1 000 000, etc.
        return currencyStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return currencyStr;
    },
  },
};
</script>

<style scoped>
.product-header {
  position: relative;
  margin-bottom: 1rem;
}

.tagline {
  font-family: Georgia, "Times New Roman", Times, serif;
  font-size: 1.6rem;
  font-weight: 400;
}

.deadline {
  padding: 0.4rem 0.5rem;
  font-weight: 700;
  font-size: 1.2rem;
  background: var(--wwfBlack);
}

.goal-wrapper {
  margin-top: 2rem;
}

.goal {
  margin-bottom: 2rem;
  font-family: "WWFRegular", sans-serif;
  font-size: 2rem;
}

.progress-bar-wrapper {
  width: 100%;
  height: 23px;
  margin: 1.5rem 0 1rem;
  background-color: var(--wwfWhite);
  border-radius: 16px;
  box-shadow: 4px 2px 30px -4px rgb(0 0 0 / 50%);
  overflow: hidden;
}

.progress-bar-inner {
  width: 100%;
  height: 100%;
  background-color: var(--wwfRegenerateSupportGreen);
  border-radius: 16px;
}

@media only screen and (min-width: 641px) {
  .product-header {
    margin-bottom: 4rem;
  }
  .goal-wrapper {
    width: 50%;
    margin-top: 4rem;
  }
}
@media only screen and (min-width: 1025px) {
  h1 {
    font-size: 5.5rem;
  }
  .product-header {
    margin-bottom: 4rem;
  }
  .goal-wrapper {
    position: absolute;
    left: 0px;
    bottom: -12rem;
  }
}
</style>


// WEBPACK FOOTER //
// ImpactProjectHeader.vue?750b6a6a